<template>
	<div>
	<!-- 	<el-row>
		
			<el-col :offset="3" :span="17" >
				
				<img  @click="back()" src="https://qq-gjx.oss-cn-shanghai.aliyuncs.com/pc/logo.png" height="100" style="margin-top: -15px; cursor: pointer;
				" />
			
			</el-col>
			<br>
			
			
				<el-col :span="4" style="text-align: right;">
					       <el-button style="margin-top: 2%; " type="primary" @click="copyToClipboard()">复制链接</el-button>	
								<el-button style="margin-top: 2%; " @click="openPay()"> 捐赠</el-button>	
		
				</el-col>
		</el-row> -->
		<!-- {{item.name}} -->
		<div style="position: fixed; top: 80%; left: 95%;  cursor: pointer;
				 "> 
			
			  <el-tooltip  content="点我回首页" placement="top"  v-model="show">
			    <img src="https://lqcpws.cn/tinyfile/1717508916810-首页.png"
			    width="35px" height="40px" title="回首页" @click="back()"/>
			  </el-tooltip>
		</div>
		
		<iframe :src="item.path" style="height: 1000px;width: 100%; border: none;"   ></iframe>
	   
	</div>
</template>

<script>
	export default {
	  data() {
	    return {
	      item:{path:'',name:'详情'},
		  show:true
		
	    };
		
	  },
	  methods: {
		  openPay(){
		  			window.open("https://www.lqcpws.cn/tools/pay/","_blank")	
		  },
		  back(){
			  window.location.href='/'
		  },
		  copyToClipboard() {
		    // 创建一个临时的 textarea 元素
		    var textarea = document.createElement("textarea");
		    // 设置其内容为需要复制的文本
		    textarea.value = this.item.path;
		    // 将其添加到 DOM 中
		    document.body.appendChild(textarea);
		    // 选中文本
		    textarea.select();
		    // 复制文本到剪贴板
		    document.execCommand("copy");
		    // 移除元素
		    document.body.removeChild(textarea);
			
			this.$message.success('复制工具链接成功,可以单独打开链接使用！')
		  }
	
	  },
	  mounted() {
	 
	let str= localStorage.getItem('/detail')
	if(str==undefined||str==''){
		window.location.href='/'
	}else{
		this.item=JSON.parse(str)
		
	}

	  }
	};
</script>


<style>
</style>